// extracted by mini-css-extract-plugin
export default {"error":"J40pg","icon":"RVB3W","title":"uAwmT","text":"rNUVa","button":"FlKvm"};